// Showdown default options based on the showdown defaults
const SHOWDOWN_DEFAULTS = {
  backslashEscapesHTMLTags: false,
  completeHTMLDocument: false,
  disableForced4SpacesIndentedSublists: false,
  ellipsis: true,
  emoji: false,
  encodeEmails: true,
  // excludeTrailingPunctuationFromURLs: false,
  ghCodeBlocks: true,
  ghCompatibleHeaderId: false,
  ghMentions: false,
  ghMentionsLink: 'https://github.com/{u}',
  headerLevelStart: false,
  literalMidWordAsterisks: false,
  literalMidWordUnderscores: false,
  metadata: false,
  noHeaderId: false,
  omitExtraWLInCodeBlocks: false,
  openLinksInNewWindow: false,
  parseImgDimensions: false,
  prefixHeaderId: false,
  rawHeaderId: false,
  rawPrefixHeaderId: false,
  requireSpaceBeforeHeadingText: false,
  simpleLineBreaks: false,
  simplifiedAutoLink: false,
  smartIndentationFix: false,
  smoothLivePreview: false,
  splitAdjacentBlockquotes: false,
  strikethrough: false,
  tables: false,
  tablesHeaderId: false,
  tasklists: false,
  underline: false
} satisfies Partial<showdown.Settings>

export default class StringUtils {

  public static removeSpaces = (val: string) => {
    return val.replace(/\s/g, '')
  }

  public static removeZeroWidthChars = (val: string) => {
    return val.replace(/[\u200B-\u200D\uFEFF]/g, '')
  }

  public static makeMarkdownHtml(input: string, options?: Partial<showdown.Settings>) {
    // Override with our preferred defaults
    const ourDefaults = {
      openLinksInNewWindow: true
    }

    const _options = { ...SHOWDOWN_DEFAULTS, ...ourDefaults, ...options }
    const converter = new showdown.Converter(_options)

    // Pre-process the input to handle paragraph tags
    const processedInput = input.replace(/<p>/g, '').replace(/<\/p>/g, '\n')

    return converter.makeHtml(processedInput)
  }

  public static toPureText = (value: string) => {
    const html = this.makeMarkdownHtml(value)
    
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const text = doc.body.textContent || doc.body.innerText || ''
    
    return text.trim()
  }
}
